module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "value-crud-action"
  }, [(!_vm.exclude.includes('show')) ? _c('collection-value-show-action', {
    attrs: {
      "item": _vm.item,
      "model": _vm.model
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.exclude.includes('edit')) ? _c('collection-value-edit-action', {
    attrs: {
      "item": _vm.item,
      "model": _vm.model
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.exclude.includes('delete')) ? _c('collection-value-delete-action', {
    attrs: {
      "item": _vm.item,
      "model": _vm.model
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f4ea886","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataDisplay/CollectionValues/CollectionValueCrudAction.vue
// module id = 1814
// module chunks = 0